const sectionCardSonaCss = `
[data-type='section-card-sona'] [data-attribute='card-container'] {
  padding: 40px 0;
}

[data-type='section-card-sona'] .wrap-card {
  display: flex;
  flex-wrap: wrap;
  padding-top: 0;
  padding-bottom: 0;
}

[data-type='section-card-sona'] .wrap-card .card-item-image {
  width: 50%;
}

[data-type='section-card-sona'] .wrap-card .card-item-image .wrap-img {
  position: relative;
  overflow: hidden;
  min-height: 100%;
  padding-bottom: 50%;
}

[data-type='section-card-sona'] .wrap-card .card-item-image .wrap-img img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-card-sona'] .wrap-card .card-item-content {
  width: 50%;
  padding: 15px 20px;
  display: flex;
  flex-direction: column;
}

[data-type='section-card-sona'] .wrap-card .card-item-content[data-style-center-y='true'] {
  justify-content: center;
}

[data-type='section-card-sona'] .wrap-card .card-item-content .card-content {
  margin-bottom: 20px !important;
}

[data-type='section-card-sona'] .wrap-card .card-item-content .card-content h1,
[data-type='section-card-sona'] .wrap-card .card-item-content .card-content h2,
[data-type='section-card-sona'] .wrap-card .card-item-content .card-content h3 {
  font-size: 24px;
  line-height: 29px;
  margin: 0 0 9px 0 !important;
}

[data-type='section-card-sona'] .wrap-card .card-item-content .row-btn {
  justify-content: center;
  text-align: center;
}

[data-type='section-card-sona'] .wrap-card .card-item-content .row-btn .card-btn {
  display: inline-flex;
  width: -moz-max-content;
  width: max-content;
  text-decoration: none;
  padding: 10px 40px;
  font-size: 14px;
  font-weight: bold !important;
  line-height: 20px;
  color: var(--button-text-color, #ffffff);
}

@container (max-width: 768px) {
  [data-type='section-card-sona'] [data-attribute='card-container'] {
    padding: 16px 0;
  }

  [data-type='section-card-sona'] .wrap-card .card-item-image {
    width: 100%;
    order: 1 !important;
    margin-bottom: 20px !important;
  }

  [data-type='section-card-sona'] .wrap-card .card-item-content {
    width: 100%;
    order: 2 !important;
  }

  [data-type='section-card-sona'] .wrap-card .card-item-content .card-content h1,
  [data-type='section-card-sona'] .wrap-card .card-item-content .card-content h2,
  [data-type='section-card-sona'] .wrap-card .card-item-content .card-content h3 {
    font-size: 16px;
    line-height: 24px;
  }
}
`;

export default sectionCardSonaCss;
